import React from "react";
import { useUserStore } from "./login/loginStore";
import { Link } from "@heroui/link";
import { Button } from "@heroui/button";
import { useTranslation } from 'react-i18next';

type PremiumGuardProps = {
    children: React.ReactNode;
    bypass?: boolean;
};

const PremiumGuard: React.FC<PremiumGuardProps> = ({ children, bypass = false }) => {
    const { t } = useTranslation();
    const user = useUserStore((state) => state);

    return (
        <div className="transition relative">
            <div className={user.premium || bypass ? "" : "filter blur pointer-events-none"}>
                {children}
            </div>
            {(!user.premium && !bypass) && (
                <div className="fadeIn absolute top-0 flex h-full w-full items-center justify-center px-4 transition">
                    <div className="flex flex-col items-center gap-2 rounded-medium bg-default-100 shadow-lg p-4">
                        <p className="font-bold text-lg">{t('premium_guard.premium_guard_1')}</p>
                        <p className="mt-2">
                            {t('premium_guard.premium_guard_2')}
                            <Link href='/plans' className="font-bold">
                                {t('premium_guard.premium_guard_3')}
                            </Link>
                            {t('premium_guard.premium_guard_4')}
                        </p>
                        <Link href='/plans' className="flex w-full">
                            <Button className="font-bold text-lg bg-primary w-full">{t('premium_guard.premium_guard_5')}</Button>
                        </Link>
                    </div>
                </div>
            )}
        </div>
    );
};

export default PremiumGuard;
